module.exports = window["MaterialUI"].Fab;